import script from "./ArtistSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__